import React from "react";
import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Mail } from "lucide-react";
import config from "../config";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { company } = config;

  return (
    <footer className="border-t border-white/10 bg-slate-950">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="mb-4 flex items-center gap-3 text-white no-underline"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-cyan-500 to-purple-500 text-sm font-extrabold text-white">
                T5
              </span>
              <span className="text-lg font-bold tracking-tight">
                {company.name}
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              {company.tagline}
            </p>
            <div className="mt-5 flex gap-4">
              {company.social.github && (
                <a
                  href={company.social.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-500 transition-colors hover:text-cyan-400"
                  aria-label="GitHub"
                >
                  <Github size={20} />
                </a>
              )}
              {company.social.linkedin && (
                <a
                  href={company.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-500 transition-colors hover:text-cyan-400"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
              )}
              {company.social.twitter && (
                <a
                  href={company.social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-500 transition-colors hover:text-cyan-400"
                  aria-label="Twitter"
                >
                  <Twitter size={20} />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-300">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-slate-400 hover:text-cyan-400">
                Home
              </Link>
              <Link to="/services" className="text-sm text-slate-400 hover:text-cyan-400">
                Services
              </Link>
              <Link to="/portfolio" className="text-sm text-slate-400 hover:text-cyan-400">
                Portfolio
              </Link>
              <Link to="/contact" className="text-sm text-slate-400 hover:text-cyan-400">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-300">
              Legal
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-sm text-slate-400 hover:text-cyan-400">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-sm text-slate-400 hover:text-cyan-400">
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-300">
              Contact
            </h4>
            <div className="flex flex-col gap-2">
              <a
                href={`mailto:${company.email}`}
                className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400"
              >
                <Mail size={16} /> {company.email}
              </a>
              <a
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-slate-400 hover:text-cyan-400"
              >
                {company.domain}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/5 pt-8 text-center text-sm text-slate-500">
          &copy; {currentYear} {company.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
